import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import track from 'utils/track';
import { MINDSET_ID, addMindsetAIIfRequired, getAgentElement, defaultLaunchHelixOnboardingPlanPromptDefault, sendMessageWhenIdle, useExtraSituationalAwarenessContext, useHideMindsetFloatingPanel, useHideMindsetSidebar, useMindsetLocationContext, useMindsetPageTools } from 'utils/mindset';
import useSearchParameter from 'hooks/useSearchParameter';
import Box from 'components/Box';
import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import Landmark from 'components/Landmark';
import Spinner from 'components/Spinner';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function TrialMindsetCard() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    mindsetLoadingStatus = _useState2[0],
    setMindsetLoadingStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasInitialized = _useState4[0],
    setHasInitialized = _useState4[1];
  var forceTrialOnboardingPlan = config.forceTrialOnboardingPlan;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  useHideMindsetFloatingPanel();
  useHideMindsetSidebar();
  useEffect(function () {
    function addMindset() {
      return _addMindset.apply(this, arguments);
    }
    function _addMindset() {
      _addMindset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return addMindsetAIIfRequired({
                render: true,
                search: q === null || q === void 0 ? void 0 : q.toString(),
                forceTrialOnboardingPlan: forceTrialOnboardingPlan
              });
            case 1:
              setHasInitialized(true);
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('Mindset:', _t);
              setMindsetLoadingStatus('error');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _addMindset.apply(this, arguments);
    }
    addMindset();
  }, [q, forceTrialOnboardingPlan]);

  // Shared with the floating agent in MindsetFloatingPanel, so both agents see
  // the same extra situational awareness context (coaching context,
  // uploadedTranscriptFileName, etc.) regardless of which surface set it.
  var extraSituationalAwarenessContext = useExtraSituationalAwarenessContext();
  useMindsetLocationContext(hasInitialized, MINDSET_ID, extraSituationalAwarenessContext);
  var _useMindsetPageTools = useMindsetPageTools(hasInitialized, MINDSET_ID),
    modals = _useMindsetPageTools.modals;

  // Workaround until forcePlanUid is fixed for the agentSession API
  var launchOnboardingPlanPrompt = config.helixMindsetLaunchTrialPlanPrompt || defaultLaunchHelixOnboardingPlanPromptDefault;
  var useLaunchPrompt = config.enableHelixMindsetLaunchTrialPlanPrompt;
  useEffect(function () {
    if (!hasInitialized || !useLaunchPrompt) return;
    sendMessageWhenIdle(getAgentElement(MINDSET_ID), launchOnboardingPlanPrompt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasInitialized]);
  useEffect(function () {
    // Ideally I would update this row when the component unmounts, but for now I'm creating 2 entries in case the browser is closed
    track('featureUsage', 'mindset');
    var openTime = Date.now();
    return function () {
      var duration = Date.now() - openTime;
      var durationInSeconds = Math.round(duration / 1000);
      track('featureUsage', 'mindset', durationInSeconds);
    };
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Card, {
      position: "relative",
      height: "70vh",
      pb: "m",
      children: [mindsetLoadingStatus === 'loading' && /*#__PURE__*/_jsx(CenterContent, {
        fillParent: true,
        children: /*#__PURE__*/_jsx(Spinner, {})
      }), mindsetLoadingStatus === 'error' && /*#__PURE__*/_jsx(CenterContent, {
        fillParent: true,
        children: /*#__PURE__*/_jsx(Landmark, {
          icon: "logout",
          children: t('error_could_not_load_data')
        })
      }), /*#__PURE__*/_jsx(Box, {
        height: "100%",
        id: MINDSET_ID,
        onLoadCapture: function onLoadCapture() {
          return setMindsetLoadingStatus('success');
        }
      })]
    }), modals]
  });
}
export default TrialMindsetCard;